import PropTypes from 'prop-types';
import { useEffect } from 'react';

import Heading from 'shopper/components/Heading';
import Text from 'shopper/components/Text';

import Anchor from 'components/Anchor';
import Image from 'components/Image';

import useMyBlackFridayScheduler from 'hooks/useMyBlackFridayScheduler';

import { sendEvent } from 'lib/gtag';
import placeholder from 'lib/placeholder';
import { sendSupixEvent } from 'lib/supix';

import OffersListCarousel from './OffersListCarousel';

const OffersListGameTab = ({ gaEventCategory }) => {
  const { getCampaignByType } = useMyBlackFridayScheduler();
  const offersBannerCampaign = getCampaignByType('OFFERS_BANNER');

  useEffect(() => {
    sendSupixEvent('/car', { category: 100010200 });
  }, []);

  return (
    <div>
      <Heading className="mb-2" size="size4">
        {placeholder('titles.bestOffersGame')}
      </Heading>
      <Text className="mb-3">{placeholder('subtitles.seeTheBestOffers')}</Text>
      <OffersListCarousel gaEventCategory={gaEventCategory} />
      {offersBannerCampaign && (
        <Anchor
          href={offersBannerCampaign.url}
          rel="noopener noreferrer"
          target="_blank"
          onClick={() => {
            sendEvent({
              action: 'my_bf_offer_banner',
              category: gaEventCategory,
            });
          }}
        >
          <Image
            alt={`Imagem da loja ${offersBannerCampaign.name}`}
            className="mb-12 block h-fit w-full rounded-4 md:hidden"
            height={90}
            src={offersBannerCampaign.images.mobile}
            width={350}
          />
          <Image
            alt={`Imagem da loja ${offersBannerCampaign.name}`}
            className="mb-12 hidden h-fit w-full rounded-4 md:block"
            height={170}
            src={offersBannerCampaign.images.desktop}
            width={1370}
          />
        </Anchor>
      )}
    </div>
  );
};

OffersListGameTab.propTypes = {
  gaEventCategory: PropTypes.string.isRequired,
};

export default OffersListGameTab;
